<template>
  <div>
    <a-modal width="85%" v-model="leafletsible" style="top: 20px" footer="" title="派单">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <a-row v-if="reslist.orderId" style="margin-left: 50px">
            <a-col :span="6">
              企业简称:{{ this.reslist.enterpriseSysName }}
              <a-form-item label="企业简称" style="display: none">
                <a-input v-decorator="['enterpriseSysName']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              品牌: {{ this.reslist.brandName }}
              <a-form-item label="品牌" style="display: none">
                <a-input v-decorator="['brandName']" disabled="disabled" />
              </a-form-item>
              <a title="复制" style="margin-left: 5px">
                <a-icon type="copy" class="copy" @click="Copys" />
              </a>
            </a-col>
            <a-col :span="6">
              型号: {{ this.reslist.modelName }}
              <a-form-item label="型号" style="display: none">
                <a-input v-decorator="['modelName']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="reslist.orderId" style="margin-left: 50px">
            <a-col :span="6">
              客户姓名:{{ this.reslist.clientName }}
              <a-form-item label="客户姓名" style="display: none">
                <a-input v-decorator="['clientName']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              联系方式: {{ this.reslist.clientPhone }}
              <a-form-item label="联系方式" style="display: none">
                <a-input v-decorator="['clientPhone']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              客户地址: {{ this.reslist.clientAddress }}
              <a-form-item label="客户地址" style="display: none">
                <a-input v-decorator="['clientAddress']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>
          <div style="margin: 20px; background-color: #e6f7ff" v-if="reslist.orderId">
            <a-row style="padding: 0px">
              <a-col :span="24" class="orderKeyword">
                <span>派单要求</span>
              </a-col>
            </a-row>
            <div v-if="dispatchdemandlist">
              <ul v-for="item in dispatchdemandlist">
                <li>
                  <span>{{ item.demandContent }}</span><span style="margin-left: 30px">{{ item.updateTime }}</span><span
                    style="margin-left: 15px"> {{ item.updateBy }}</span>
                </li>
              </ul>
            </div>
          </div>
          <a-row v-if="reslist.orderId">
            <a-col :span="6">
              <a-form-item label="企业总金额" style="width: 296px; margin-left: 20px">
                <a-input v-decorator="['totalAmount']" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-button type="primary" style="margin-left: 10px" @click="allView"> 查看全部 </a-button>
            </a-col>
          </a-row>
          <a-table size="default" ref="table" rowKey="orderId" :columns="columns"
            :dataSource="this.reslist.totalCostList" bordered :pagination="false" v-if="reslist.orderId">
          </a-table>
          <a-row style="margin-left: 20px; margin-top: 20px">
            <a-col :span="5">
              <a-form-item label="姓名/电话">
                <a-input v-decorator="['nameOrPhone']" />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="省" style="margin-left: 10px">
                <a-select @change="getselect" v-decorator="['provinceId']" :allowClear="false">
                  <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">
                    {{ type.provinceName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="市" style="margin-left: 10px">
                <a-select v-decorator="['cityId']" @change="getprovinceName" :allowClear="true">
                  <a-select-option v-for="type in selectCityName" :key="type.cityCode">
                    {{ type.cityName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4" style="margin-left: 10px">
              <a-form-item label="区">
                <a-select v-decorator="['countyId']" :allowClear="true">
                  <a-select-option v-for="type in selectAreaName" :key="type.areaCode">
                    {{ type.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="" style="width: 100%">
                <a-button type="primary" style="margin-left: 10px" @click="masterleafletsInquiry"> 查询师傅 </a-button>
                <a-button type="primary" style="margin-left: 10px" @click="masterQuery"> 默认查询 </a-button>

                <a-button type="primary" style="margin-left: 10px" @click="masterInquiry"> 查询历史师傅 </a-button>
              </a-form-item>
            </a-col>
            <!--<a-col :span="2">-->
            <!--<a-form-item label="渠道负责人" style="width: 296px;margin-left: 50px;">-->
            <!--<a-input v-decorator="['areaPrincipal']" disabled="disabled"/>-->
            <!--</a-form-item>-->
            <!--</a-col>-->
          </a-row>
          <a-row style="margin-left: 20px">
            <a-col :span="5">
              <a-form-item label="渠道负责人">
                <a-input v-decorator="['areaPrincipal']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-table size="default" ref="table" rowKey="orderId" :columns="distributecolumns"
            :dataSource="this.distributedata" bordered :pagination="false" :scroll="{ x: 1800 }">
            <span slot="action" slot-scope="text, record">
              <a @click="changePrice(record)">改价 </a>
              <a-divider type="vertical" />
              <a @click="leafletsDistribute(record)">派单</a>
            </span>
            <span slot="creditScore" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <LockanRadar :no="record.no" :data="record.data" :data1="record.data1" :indicator="record.indicator">
                  </LockanRadar>
                </template>
                <a type="primary">
                  <!--<LockanRadar :no="record.no" :data="record.data" :data1="record.data1" :indicator="record.indicator"></LockanRadar>-->
                  {{ record.creditScore }}
                </a>
              </a-popover>
            </span>
            <span slot="phoneNumber" slot-scope="text, record">
              <a-popover title="备用号码">
                <template slot="content">
                  <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
                    <p>{{ record.contactReserve }}</p>
                  </div>
                </template>
                <a type="primary">
                  {{ record.phoneNumber }}
                </a>
              </a-popover>
            </span>
          </a-table>
        </a-form>
      </div>
    </a-modal>
    <a-modal :mask="false" style="top: 20px" :width="650" v-model="chartRadarible" footer="">
      <div @click="clickMe" id="myChart" :style="{ width: '500px', height: '500px', marginLeft: '50px' }"></div>
    </a-modal>
    <a-modal style="top: 40px" title="提示" :width="400" v-model="auditAmountible" footer=""
      @cancel="auditAmountiblecancel">
      <P v-for="item in MasterInforows">{{ item }}</P>
      <!--订单号-->
    </a-modal>
    <enterprise-details ref="details"></enterprise-details>
    <edit-order-model v-if="$store.state.user_type == 1" ref="editordermodel" @ok="$refs.table.refresh(true)">
    </edit-order-model>
    <edit-order-model1 v-else ref="editordermodel" @ok="$refs.table.refresh(true)"></edit-order-model1>
  </div>
</template>
<script>
import { getdemandlist } from '@/api/order/NewlyaddedOrderList'
import { LockanRadar } from '@/components'
import EnterpriseDetails from '@/views/enterprise/EnterpriseDetails'
import pick from 'lodash.pick'
import G2 from '@antv/g2'
import { getselectAllProvince, getselectCityName, getselectAreaName } from '@/api/order/orderList'
import {
  getselectAreaPrincipalList,
  getselectAreaPrincipalByCityId,
  getselectPriceName,
  getmasterList,
  getupdateOrderMasterInfo,
  gethistoryMaster
} from '@/api/order/leafletsDistribute'
export default {
  name: 'LeafletsDistribute',
  components: {
    EnterpriseDetails,
    LockanRadar,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1')
    // 注册弹框组件
  },
  data() {
    return {
      copyData: '',
      isTemporarilySettle: '',
      dividerdis: false,
      auditAmountible: false,
      leafletsible: false,
      searchParam: '',
      chartRadarible: false,
      distributedata: [],
      MasterInforows: [],
      distributecolumns: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '姓名',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phoneNumber',
          scopedSlots: { customRender: 'phoneNumber' },
          align: 'center'
        },

        {
          title: '师傅金额',
          dataIndex: 'masterPrice',
          align: 'center'
        },
        {
          title: '师傅类型',
          dataIndex: 'type',
          align: 'center'
        },

        {
          title: '标签',
          dataIndex: 'label',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '提现周期',
          dataIndex: 'cashCycle',
          align: 'center'
        },
        {
          title: '近30天接单',
          dataIndex: 'orderNumIn30Days',
          align: 'center'
        },

        {
          title: '未销单',
          dataIndex: 'installOrderNo',
          align: 'center'
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterLeadingName'
        },
        {
          title: '等级',
          dataIndex: 'level',
          align: 'center'
        },

        {
          title: '提现方式',
          dataIndex: 'cashStatus',
          align: 'center'
        },
        {
          title: '接单方式',
          dataIndex: 'receiptType',
          align: 'center'
        },
        {
          title: '平台',
          dataIndex: 'platform',
          align: 'center'
        },
        {
          title: '信用分',
          dataIndex: 'creditScore',
          scopedSlots: { customRender: 'creditScore' },
          align: 'center'
        },
      ],
      selectAllProvince: [],
      selectCityName: [],
      selectAreaName: [],
      reslist: '',
      form: this.$form.createForm(this),
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '金额类型',
          dataIndex: 'priceType',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center'
        },
        {
          title: '初始单价',
          dataIndex: 'initialPrice',
          align: 'center'
        },
        {
          title: '初始金额',
          dataIndex: 'initialAmount',
          align: 'center'
        },
        {
          title: '修改金额',
          dataIndex: 'changeAmount',
          align: 'center'
        },
        {
          title: '现订单金额',
          dataIndex: 'nowAmount',
          align: 'center'
        },
        {
          title: '金额备注',
          dataIndex: 'priceRemark',
          align: 'center'
        }
      ],
      showchartrecord: '',
      enterpriseamount: false,
      dispatchdemandlist: [],
      disabled: true
    }
  },

  methods: {
    // 复制
    handcopy(data) {
      const url = data
      const oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    Copys() {
      const brandName = this.form.getFieldValue('brandName') ? this.form.getFieldValue('brandName') : ''
      const modelName = this.form.getFieldValue('modelName') ? this.form.getFieldValue('modelName') : ''
      const clientName = this.form.getFieldValue('clientName') ? this.form.getFieldValue('clientName') : ''
      const clientPhone = this.form.getFieldValue('clientPhone') ? this.form.getFieldValue('clientPhone') : ''
      const clientAddress = this.form.getFieldValue('clientAddress') ? this.form.getFieldValue('clientAddress') : ''
      this.copyData =
        `品牌: ` +
        brandName +
        '\n' +
        `型号: ` +
        modelName +
        '\n' +
        `客户姓名: ` +
        clientName +
        '\n' +
        `联系方式: ` +
        clientPhone +
        '\n' +
        `客户地址: ` +
        clientAddress
      this.handcopy(this.copyData)
    },
    masterleafletsInquiry() {
      if (this.reslist.orderId) {
        getmasterList({
          installType: this.reslist.installType,
          provinceId: this.form.getFieldValue('provinceId'),
          cityId: this.form.getFieldValue('cityId'),
          districtId: this.form.getFieldValue('countyId'),
          nameOrPhone: this.form.getFieldValue('nameOrPhone'),
          orderId: this.reslist.orderId
        }).then(res => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach(item => {
              item = { ...item, ...item.priceMap }
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        getmasterList({
          installType: this.searchParam.installType,
          provinceId: this.form.getFieldValue('provinceId'),
          cityId: this.form.getFieldValue('cityId'),
          nameOrPhone: this.form.getFieldValue('nameOrPhone'),
          districtId: this.form.getFieldValue('countyId')
        }).then(res => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach(item => {
              item = { ...item, ...item.priceMap }
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    masterQuery() {
      this.showleaflets(this.reslist)
    },
    masterInquiry() {
      if (this.reslist.orderId) {
        gethistoryMaster({
          installType: this.reslist.installType,
          provinceId: this.reslist.provinceId,
          cityId: this.reslist.cityId,
          districtId: this.reslist.countyId,
          orderId: this.reslist.orderId,
          nameOrPhone: this.form.getFieldValue('nameOrPhone')
        }).then(res => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach(item => {
              item = { ...item, ...item.priceMap }
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        gethistoryMaster({
          installType: this.searchParam.installType,
          provinceId: this.searchParam.provinceId,
          districtId: this.searchParam.districtId,
          nameOrPhone: this.form.getFieldValue('nameOrPhone')
        }).then(res => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach(item => {
              item = { ...item, ...item.priceMap }
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    async showleaflets(reslist) {
      this.reslist = reslist
      if (this.reslist.orderId) {
        this.dividerdis = true
        this.leafletsible = true
        this.selectAreaName = []
        getselectAreaName({ cityCode: this.reslist.cityId }).then(res => {
          if (res.code === 0) {
            this.selectAreaName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        // // 查询企业要求列表
        getdemandlist({
          demandType: 'dispatch_order_demand',
          model: this.reslist.modelId,
          orderType: this.reslist.orderType,
          enterpriseId: this.reslist.enterpriseId
        }).then(res => {
          if (res.code === 0) {
            this.dispatchdemandlist = res.data.demandList.dispatch_order_demand
            // console.log(this.dispatchdemandlist)
          } else {
            this.$message.error(res.msg)
          }
        })
        // this.distributecolumns = [
        //   {
        //     title: '序号',
        //     dataIndex: 'no',
        //     align: 'center'
        //   },
        //   {
        //     title: '操作栏',
        //     dataIndex: 'action',
        //     scopedSlots: { customRender: 'action' }
        //   },
        //   {
        //     title: '姓名',
        //     dataIndex: 'name',
        //     align: 'center'
        //   },
        //   {
        //     title: '联系方式',
        //     dataIndex: 'phoneNumber',
        //     scopedSlots: { customRender: 'phoneNumber' },
        //     align: 'center'
        //   },
        //   {
        //     title: '信用分',
        //     dataIndex: 'creditScore',
        //     scopedSlots: { customRender: 'creditScore' },
        //     align: 'center'
        //   },
        //   {
        //     title: '师傅类型',
        //     dataIndex: 'type',
        //     align: 'center'
        //   },
        //   {
        //     title: '师傅负责人',
        //     dataIndex: 'masterLeadingName'
        //   },
        //   {
        //     title: '标签',
        //     dataIndex: 'label',
        //     align: 'center'
        //   },
        //   {
        //     title: '备注',
        //     dataIndex: 'remark'
        //   },
        //   {
        //     title: '提现周期',
        //     dataIndex: 'cashCycle',
        //     align: 'center'
        //   },
        //   {
        //     title: '近30天接单',
        //     dataIndex: 'orderNumIn30Days',
        //     align: 'center'
        //   }
        // ]
        // this.distributecolumnsLast = [
        //   {
        //     title: '未销单',
        //     dataIndex: 'installOrderNo',
        //     align: 'center'
        //   },
        //   {
        //     title: '等级',
        //     dataIndex: 'level',
        //     align: 'center'
        //   },

        //   {
        //     title: '提现方式',
        //     dataIndex: 'cashStatus',
        //     align: 'center'
        //   },
        //   {
        //     title: '接单方式',
        //     dataIndex: 'receiptType',
        //     align: 'center'
        //   },
        //   {
        //     title: '平台',
        //     dataIndex: 'platform',
        //     align: 'center'
        //   }
        // ]
        // getselectPriceName({ orderIdList: [this.reslist.orderId] }).then(res => {
        //   if (res.code === 0) {
        //     this.distributecolumns = this.distributecolumns.concat(res.data.list, this.distributecolumnsLast)
        //   } else {
        //     this.$message.error(res.msg)
        //   }
        // })
        await getmasterList({
          installType: this.reslist.installType,
          provinceId: this.reslist.provinceId,
          cityId: this.reslist.cityId,
          districtId: this.reslist.countyId,
          orderId: this.reslist.orderId
        }).then(res => {
          if (res.code === 0) {
            this.distributedata = []
            res.rows.forEach(item => {
              item = { ...item, ...item.priceMap }
              this.distributedata.push(item)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        this.selectCityName = []
        getselectCityName({ provinceCode: this.reslist.provinceId }).then(res => {
          if (res.code === 0) {
            /* console.log(res) */
            this.selectCityName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.reslist,
              'brandName',
              'clientAddress',
              'clientName',
              'clientPhone',
              'areaPrincipal',
              'enterpriseSysName',
              'modelName',
              'totalAmount',
              'provinceId',
              'cityId',
              'countyId'
            )
          )
        })
      } else {
        this.dividerdis = false
        getselectPriceName({ orderIdList: this.reslist }).then(res => {
          if (res.code === 0) {
            this.leafletsible = true
            // this.distributecolumns = this.distributecolumns.concat(res.data.list, this.distributecolumnsLast)
            // 批量返回的数据
            this.searchParam = res.data.searchParam
            getmasterList({
              installType: res.data.searchParam.installType,
              provinceId: res.data.searchParam.provinceId,
              cityId: res.data.searchParam.cityId,
              districtId: res.data.searchParam.districtId
            }).then(res => {
              if (res.code === 0) {
                this.distributedata = []
                res.rows.forEach(item => {
                  item = { ...item, ...item.priceMap }
                  this.distributedata.push(item)
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    allView() {
      this.$refs.details.edit(this.reslist.enterpriseId, '2', '0', '', 1)
    },
    changePrice(record) {
      console.log(record)
      // 单个派单带过来的数据
      if (this.reslist.orderId) {
        const that = this
        getupdateOrderMasterInfo({
          orderIdList: [this.reslist.orderId],
          userId: record.userId,
          name: record.name,
          phoneNumber: record.phoneNumber
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.leafletsible = false
            this.$emit('ok')
            this.$emit('leafletsok')
            this.$nextTick(() => {
              that.$refs.editordermodel.showeditOrder(this.reslist.orderId, 2, 1, '', '待审核')
            })
            setTimeout(function () {
              that.$refs.editordermodel.changePrice()
            }, 1000)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        getupdateOrderMasterInfo({
          orderIdList: this.reslist,
          userId: record.userId,
          name: record.name,
          phoneNumber: record.phoneNumber
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.leafletsible = false
            this.$nextTick(() => {
              that.$refs.editordermodel.showeditOrder(this.reslist.orderId, 2, 1, '', '待审核')
            })
            setTimeout(function () {
              that.$refs.editordermodel.changePrice()
            }, 1000)
            this.$emit('ok')
            this.$emit('leafletsok')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    auditAmountiblecancel() {
      this.leafletsible = false
      this.auditAmountible = false
    },
    leafletsDistribute(record) {
      console.log(record)
      // this.auditAmountible=true
      if (this.reslist.orderId && this.disabled) {
        this.disabled = false
        getupdateOrderMasterInfo({
          orderIdList: [this.reslist.orderId],
          userId: record.userId,
          name: record.name,
          phoneNumber: record.phoneNumber,
          type: 1
        }).then(res => {
          if (res.code === 0) {
            console.log()
            if (res.rows.length > 0) {
              this.MasterInforows = res.rows

              this.auditAmountible = true
            } else {
              this.leafletsible = false
            }
            this.$emit('ok')
            this.$emit('leafletsok')
            this.disabled = true
            this.$emit('update')
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (this.disabled) {
        this.disabled = false
        getupdateOrderMasterInfo({
          orderIdList: this.reslist,
          userId: record.userId,
          name: record.name,
          phoneNumber: record.phoneNumber,
          type: 2
        }).then(res => {
          if (res.code === 0) {
            if (res.rows.length > 0) {
              this.MasterInforows = res.rows
              this.auditAmountible = true
            } else {
              this.leafletsible = false
            }
            this.$emit('ok')
            this.$emit('leafletsok')
            this.$message.success('操作成功')
            this.disabled = true
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    selectAreaNamechange(e) {
      // if(e){
      // }
    },
    showchartRadar(record) {
      this.chartRadarible = true
      // this.showchartrecord=record
      this.$nextTick(function () {
        this.drawLine(record.indicator, record.data, record.data1)
      })
    },
    drawLine(indicator, data, data1) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('myChart'))
      // let legenddata=[]
      //   data.forEach(item=>{
      //     legenddata.push(item.name)
      // })
      console.log(indicator, data)
      // 绘制图表
      myChart.setOption({
        title: {
          text: '雷达图'
        },
        tooltip: {},
        legend: {
          data1
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator,
          center: ['50%', '50%'],
          radius: 80
        },
        series: [
          {
            // name: '预算 vs 开销（Budget vs spending）',
            type: 'radar',
            data
          }
        ]
      })
    },
    clickMe() {
      this.chartRadarible = false
    },
    offchartRadar() {
      // this.chartRadarible=false
    },
    /* 获取市 省更改 */
    getselect(e) {
      // if(e){
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          /* console.log(res) */
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      getselectAreaPrincipalList({ provinceId: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.form.setFieldsValue({
            areaPrincipal: res.data
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      // }

      this.form.setFieldsValue({
        cityId: ''
      })
      this.form.setFieldsValue({
        countyId: ''
      })
    },
    /* 获取区 市更改 */
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          /* console.log(res) */
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      this.form.setFieldsValue({
        countyId: ''
      })

      // getselectAreaPrincipalList({cityId: e}).then(res => {
      //     if (res.code === 0) {
      //       // console.log(res)
      //       this.form.setFieldsValue({
      //         areaPrincipal: res.data,
      //       });
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   })
    }
  },
  async created() {
    this.selectAllProvince = []
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        /* console.log('aaaaaaaaaaaaa') console.log(res) */
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
